import React from 'react';
import { Link } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
const GlobalStyle = createGlobalStyle`
 @media all and (max-width: 768px) {.login-container{
background:transparent !important}}`;
const ForgotPasswordContent = () => {
  return (
    <Wrapper className="content-box-wrapper">
      <GlobalStyle />
      <span className="heading">
        Forgot your
        <b>password?</b>
      </span>
      <p className="sub-title">
        Don't worry! We can help you reset the password using your email ID.
      </p>
      <img src="/images/forgot_password.png" className={`gpk`} alt="Graphic" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .heading {
    b {
      display: block;
    }
  }
  .gpk {
    position: relative;
    bottom: 20px;
    z-index: -1;
    width: 75%;
    max-width: 350px;
    margin-top: 60px;
    display: block !important;
  }
  @media all and (max-width: 768px) {
    .gpk {
      margin: auto;
      margin-top: 40px;
      z-index: 1;
    }
  }
  @media all and (max-width: 520px) {
    .gpk {
      max-width: 200px;
      margin: auto;
      margin-top: 40px;
      z-index: 1;
    }
    .heading {
      b {
        display: inline-block;
        padding-left: 6px;
      }
    }
  }
`;

export default ForgotPasswordContent;
